import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getTrips,postTrips,deleteTrips,
  getTripsbyId,editDrivers,postTripActions,exportShortage,editTripVehicle,getTripEvents,getTripStatus,getDiscrepancy,exportDiscrepancy} from "../../services/TripMgt/Trip_services";
const initialValues = {
 tripsDetails: [],
 tripsStatus: [],
};
let tripStore = (set) => ({
  ...initialValues,
  getTrips: async (params) => {
        const response = await getTrips(params);
        return response;
      },
      postTrips: async (params) => {
        const response = await postTrips(params);
        return response;
      },
      deleteTrips: async (params) => {
        const response = await deleteTrips(params);
        return response;
      },
      postTripActions: async (params,data) => {
        const response = await postTripActions(params,data);
        return response;
      },
      getTripsbyId: async (params) => {
        const response = await getTripsbyId(params);
        set({ tripsDetails: response });
        return response;
      },
      getTripStatus: async (params) => {
        const response = await getTripStatus(params);
        set({ tripsStatus: response });
        return response;
      },
      editDrivers: async (params,data) => {
        const response = await editDrivers(params,data);
        return response;
      },
      editTripVehicle: async (params,params2) => {
        const response = await editTripVehicle(params,params2);
        return response;
      },
      getTripEvents: async (params,params2) => {
        const response = await getTripEvents(params,params2);
        return response;
      },
      getDiscrepancy: async (params) => {
        const response = await getDiscrepancy(params);
        return response;
      },
      exportDiscrepancy: async (params) => {
        const response = await exportDiscrepancy(params);
        return response;
      },
      exportShortage: async (params) => {
        const response = await exportShortage(params);
        return response;
      }
});

tripStore = devtools(tripStore);

export const useTripStore = create(tripStore);